import React from 'react';
import PropTypes from 'prop-types';
import { styles } from './styles.js';
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import { Container } from '../Container';

const ContentContainer = ({ classes, children }) => (
  <Container>
    <Grid container spacing={4} className={classes.root}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        {children}
      </Grid>
    </Grid>
  </Container>
);

ContentContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default withStyles(styles)(ContentContainer);
